import React, {useEffect, useState} from 'react';
import PropTypes                    from 'prop-types';
import FeatureFeedbackAsPanel       from '../FeatureFeedback/FeatureFeedbackAsPanel.js';
import Flux                         from '../../flux/Flux.js';

const VXTeaserFeedback = ({teaserId}) => {
    const [featureFeedback, setFeatureFeedback] = useState(null);

    // initial render
    useEffect(() => {
        const initFeatureFeedback = Flux.Teaser.getFeedbackFeatureByTeaserId(teaserId);
        setFeatureFeedback(initFeatureFeedback);
    }, [teaserId]);

    if (!featureFeedback) {
        return null;
    }

    return (
            <FeatureFeedbackAsPanel
                    featureId={featureFeedback.id}
                    title={featureFeedback.title}
                    theme={featureFeedback.theme}
            />
    );
};

VXTeaserFeedback.propTypes = {
    teaserId: PropTypes.number,
};

export default VXTeaserFeedback;
